import { connect } from 'react-redux';
import { Helmet } from 'react-helmet-async';
import { CHECKOUT_PAGE_META } from 'lib/enums/checkout';

const mapState = () => ({
  title: 'Review and Pay | Qantas Hotels Australia',
  meta: CHECKOUT_PAGE_META,
});

export default connect(mapState)(Helmet);
